import React, { useState } from "react";
import GroqDrawer from "../components/GroqDrawer";
import YogyImg from "../assets/Yogy.jpg";

export function GroqDrawerTrigger({ openDrawer, onOpen, setQuery, systemPromptKey = "system_prompt" }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Allow parent to control opening
  React.useEffect(() => {
    if (openDrawer) setDrawerOpen(true);
  }, [openDrawer]);

  // Allow parent to get a function to open the drawer
  React.useEffect(() => {
    if (onOpen) {
      onOpen(() => setDrawerOpen(true));
    }
  }, [onOpen]);

  return (
    <>
      {/* GroqDrawer Trigger Button */}
      <div className="fixed bottom-20 right-6 z-50">
        <button
          onClick={() => setDrawerOpen(true)}
          className="rounded-2xl shadow-lg border-2 border-white dark:border-gray-700 overflow-hidden p-0 bg-white dark:bg-gray-800 hover:scale-105 transition-transform duration-200"
          style={{ width: 88, height: 88 }}
        >
          <img
            src={YogyImg}
            alt="Open Groq Assistant"
            className="object-cover w-full h-full rounded-2xl"
          />
        </button>
      </div>
      <GroqDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} setQuery={setQuery} systemPromptKey={systemPromptKey} />
    </>
  );
}
